/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import welcomeIcon from "src/assets/home/welcome.png";
import { useFormatMessage } from "src/hooks";
import messageIds from "src/locales/messageIds";

export interface LoginUser {
  name: string;
  phone_number: string;
  sub: string;
  userid: string;
  id: string;
}

export default React.memo(
  withRouter(function Home() {
    const formatMessage = useFormatMessage();
    const [user] = useState("");

    return (
      <div
        css={css`
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100%;
          flex: 1;
        `}
      >
        <div>
          <p
            css={css`
              font-size: 24px;
              font-weight: 600;
              text-align: center;
            `}
          >
            Hi,
            <span
              css={css`
                color: #3377ff;
              `}
            >
              {user}
            </span>
            {formatMessage(messageIds.home.welcome)}
          </p>
          <img alt="" src={welcomeIcon} />
        </div>
      </div>
    );
  })
);
